import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Initialize Sentry
Sentry.init({
  dsn: "https://c17905ede3bf90b3e2d806409849a683@o4510590326931456.ingest.de.sentry.io/4510619958050896",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // Only send events in production
  enabled: environment.production,
  // Add environment field to events
  environment: environment.name,
  // Set release version
  release: environment.version,
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
